













import Vue from "vue";
import { state } from "../data/state";
import { computed } from "@vue/composition-api";
import { post_fix_with_if_not_exist } from "@/utils/str.utils";
import { POPULATION_TYPE } from "@/common/models";
export default Vue.extend({
  setup() {
    const { current_subject } = state;
    const label_post_fix = post_fix_with_if_not_exist(" information");
    const main_name = computed(() => {
      if (current_subject.value.type === POPULATION_TYPE.LABEL) {
        return label_post_fix(current_subject.value.name);
      } else {
        return current_subject.value.name;
      }
    });

    return {
      current_subject,
      main_name,
    };
  },
});
